module.exports = __webpack_public_path__ + "static/media/coco_bambino.6c23819c.webp";